/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
// import { NextSeo } from 'next-seo';
import { NextRouter, withRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { BASE_URL, CASE_STUDY_VARIANTS, CASE_STUDY_VARIANTS_SP, EASING_VALUE, SEO_INFO } from 'libs/constants';
import { Layout } from 'components/templates/layout';
import { InView } from 'react-intersection-observer';
import { MaskImage } from 'components/atoms/mask-image';
import { Heading } from 'components/atoms/heading';
import { Container } from 'components/organisms/container';
import { Row } from 'components/organisms/row';
import { Col } from 'components/organisms/col';
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { useMediaQuery } from 'libs/use-media-query';
import { Button } from 'components/atoms/button';
import { BackButton } from 'components/atoms/back-button';
import { mapModifiers } from 'libs/component';

interface AboutPageProps {
  router: NextRouter;
  lang?: string;
}

const detailList = [
  {
    images: {
      sp: {
        jpg: '/images/about/p1-sp.jpg, /images/about/p1-sp@2x.jpg 2x',
        webp: '/images/about/p1-sp.webp, /images/about/p1-sp@2x.webp 2x',
      },
      pc: {
        jpg: '/images/about/p1.jpg, /images/about/p1@2x.jpg 2x',
        webp: '/images/about/p1.webp, /images/about/p1@2x.webp 2x',
      },
      img: {
        jpg: '/images/about/p1.jpg',
        webp: '/images/about/p1.webp',
      },
    },
    title: 'One and Only System for You',
    items: [
      'Customization-based system to realize flexible incorporation of financial policy and strategy specific in each country',
      'Customer-First consulting by professionals with full-settlement industry perspective to clarify the proprietary specifications ',
    ],
  },
  {
    images: {
      sp: {
        jpg: '/images/about/p2-sp.jpg, /images/about/p2-sp@2x.jpg 2x',
        webp: '/images/about/p2-sp.webp, /images/about/p2-sp@2x.webp 2x',
      },
      pc: {
        jpg: '/images/about/p2.jpg, /images/about/p2@2x.jpg 2x',
        webp: '/images/about/p2.webp, /images/about/p2@2x.webp 2x',
      },
      img: {
        jpg: '/images/about/p2.jpg',
        webp: '/images/about/p2.webp',
      },
    },
    title: 'Total Assistance with Our Great Experience & Achievements',
    items: [
      'Full range of experience of financial IT infrastructure from RTGS to ACH, ATM/Card Switching, Core Banking, etc.',
      'Flexible & Expeditious service offerings from system design to maintenance after implementation even under tight cost & timeline.',
    ],
  },
  {
    images: {
      sp: {
        jpg: '/images/about/p3-sp.jpg, /images/about/p3-sp@2x.jpg 2x',
        webp: '/images/about/p3-sp.webp, /images/about/p3-sp@2x.webp 2x',
      },
      pc: {
        jpg: '/images/about/p3.jpg, /images/about/p3@2x.jpg 2x',
        webp: '/images/about/p3.webp, /images/about/p3@2x.webp 2x',
      },
      img: {
        jpg: '/images/about/p3.jpg',
        webp: '/images/about/p3.webp',
      },
    },
    title: 'Extraordinary Support with Long Term Relationship',
    items: [
      'Quick and trusted supports by our local professionals realize stable operation.',
      'Proactive system update upon new requirement and regulation.',
    ],
  },
];

/* const preloadList = [
  // KV - JPG
  { rel: 'preload', href: '/images/about/KV-sp.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/KV-sp@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/KV.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/KV@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // KV - WEBP
  { rel: 'preload', href: '/images/about/KV-sp.webp', type: 'image/webp', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/KV-sp@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/KV.webp', type: 'image/webp', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/KV@2x.webp',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P1 - JPG
  { rel: 'preload', href: '/images/about/p1-sp.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p1-sp@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p1.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p1@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P1 - WEB
  { rel: 'preload', href: '/images/about/p1-sp.webp', type: 'image/webp', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p1-sp@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p1.webp', type: 'image/webp', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p1@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P2 - JPG
  { rel: 'preload', href: '/images/about/p2-sp.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p2-sp@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p2.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p2@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P2 - WEBP
  { rel: 'preload', href: '/images/about/p2-sp.webp', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p2-sp@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p2.webp', type: 'image/webp', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p2@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P3 - JPG
  { rel: 'preload', href: '/images/about/p3-sp.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p3-sp@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p3.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p3@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // P3 - WEBP
  { rel: 'preload', href: '/images/about/p3-sp.webp', type: 'image/webp', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/about/p3-sp@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/about/p3.webp', type: 'image/webp', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/about/p3@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // Case Study - JPG
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // Case Study - WEBP
  {
    rel: 'preload',
    href: '/images/home/case-study.webp',
    type: 'image/webp',
    as: 'image',
    media: '(max-width: 768px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study.webp',
    type: 'image/webp',
    as: 'image',
    media: '(min-width: 769px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
]; */

const AboutPage: React.FC<AboutPageProps> = ({ router }) => {
  const PAGE_KEY = 'ABOUT';
  const PAGE_SEO_INFO = (SEO_INFO as any)[PAGE_KEY] as any;
  const PAGE_URL = `${BASE_URL}/about`;

  const isSP = useMediaQuery('(max-width: 768px)');
  const { scrollY } = useViewportScroll();
  const [pageScrollY, setPageScrollY] = useState(0);
  const [sectionDimensions, setSectionDimensions] = useState({
    hero: 888,
    p1: 742,
    p2: 742,
    p3: 742,
    footer: 520,
    caseStudy: 720,
  });
  const heroSectionRef = useRef(null);
  const p1SectionRef = useRef(null);
  const p2SectionRef = useRef(null);
  const p3SectionRef = useRef(null);
  const footerSectionRef = useRef(null);
  const caseStudySectionRef = useRef(null);
  const [sectionPictureReveals, setSectionPictureReveals] = useState({
    hero: false,
    p1: false,
    p2: false,
    p3: false,
    footer: false,
    caseStudy: false,
  });

  const viewPage = (path: string) => {
    router.push(path, path, { scroll: true });
  };

  useEffect(() => {
    scrollY.onChange(v => setPageScrollY(v));
  }, [scrollY]);

  useEffect(() => {
    const detectSectionDimension = () => {
      const heroSectionEl = heroSectionRef.current as unknown as HTMLDivElement;
      const p1SectionEl = p1SectionRef.current as unknown as HTMLDivElement;
      const p2SectionEl = p2SectionRef.current as unknown as HTMLDivElement;
      const p3SectionEl = p3SectionRef.current as unknown as HTMLDivElement;
      const footerSectionEl = footerSectionRef.current as unknown as HTMLDivElement;
      const caseStudySectionEl = caseStudySectionRef.current as unknown as HTMLDivElement;

      if (heroSectionEl) {
        const rect = heroSectionEl.getBoundingClientRect();
        sectionDimensions.hero = rect.height;
      }
      if (p1SectionEl) {
        const rect = p1SectionEl.getBoundingClientRect();
        sectionDimensions.p1 = rect.height;
      }
      if (p2SectionEl) {
        const rect = p2SectionEl.getBoundingClientRect();
        sectionDimensions.p2 = rect.height;
      }
      if (p3SectionEl) {
        const rect = p3SectionEl.getBoundingClientRect();
        sectionDimensions.p3 = rect.height;
      }
      if (footerSectionEl) {
        const rect = footerSectionEl.getBoundingClientRect();
        sectionDimensions.footer = rect.height;
      }
      if (caseStudySectionEl) {
        const rect = caseStudySectionEl.getBoundingClientRect();
        sectionDimensions.caseStudy = rect.height;
      }
      setSectionDimensions(sectionDimensions);
    };

    const handleResize = () => {
      detectSectionDimension();
    };

    detectSectionDimension();

    if (window) {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (window) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [sectionDimensions]);

  const heroParallaxScrollRange = [0, sectionDimensions.hero];
  const heroParallax = {
    image: useTransform(scrollY, heroParallaxScrollRange, isSP ? [0, 0] : [0, 100]),
  };
  const heroVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
          delayChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    image: {
      enter: {
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.25,
        },
      },
      exit: {
        opacity: 0,
        scale: 1.2,
      },
    },
    title: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
          delay: 0.5,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
    description: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
          delay: 1,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  const p1ParallaxScrollRange = [heroParallaxScrollRange[0], heroParallaxScrollRange[1] + sectionDimensions.p1];
  const p2ParallaxScrollRange = [p1ParallaxScrollRange[0], p1ParallaxScrollRange[1] + sectionDimensions.p2];
  const p3ParallaxScrollRange = [p2ParallaxScrollRange[0], p2ParallaxScrollRange[1] + sectionDimensions.p3];
  const pointParallaxs = [
    { image: useTransform(scrollY, p1ParallaxScrollRange, isSP ? [0, 0] : [-100, 100]) },
    { image: useTransform(scrollY, p2ParallaxScrollRange, isSP ? [0, 0] : [-100, 100]) },
    { image: useTransform(scrollY, p3ParallaxScrollRange, isSP ? [0, 0] : [-100, 100]) },
  ];
  const pointVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    image: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
    content: {
      enter: {
        transition: {
          staggerChildren: 0.25,
          delay: 1,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    text: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  const footerParallaxScrollRange = [p3ParallaxScrollRange[0], p3ParallaxScrollRange[1] + sectionDimensions.footer];
  const footerStudyParallax = {
    line: useTransform(scrollY, footerParallaxScrollRange, isSP ? [0, 0] : [-50, 50]),
    logo: useTransform(scrollY, footerParallaxScrollRange, isSP ? [0, 0] : [200, -50]),
  };
  const footerVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    line: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
          type: 'spring',
          stiffness: 400,
          damping: 40,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
    image: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  const caseStudyParallaxScrollRange = [
    footerParallaxScrollRange[0],
    footerParallaxScrollRange[1] + sectionDimensions.caseStudy,
  ];
  const caseStudyParallax = {
    heading: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    content: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    image: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    imageText: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
  };
  const caseStudyVariants = isSP ? CASE_STUDY_VARIANTS_SP : CASE_STUDY_VARIANTS;

  return (
    <Layout pageId="/about">
      <NextSeo
        title={PAGE_SEO_INFO.title}
        description={PAGE_SEO_INFO.description}
        openGraph={{
          type: 'website',
          url: PAGE_URL,
          title: PAGE_SEO_INFO.title,
          description: PAGE_SEO_INFO.description,
          site_name: SEO_INFO.HOME.title,
        }}
        // additionalLinkTags={preloadList}
      />
      <div className="p-about">
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            zIndex: 9999,
            color: 'red',
            display: 'none',
          }}
        >
          {pageScrollY} {JSON.stringify(sectionDimensions)}
        </div>
        <InView triggerOnce>
          {({ inView, ref }) => (
            <section ref={heroSectionRef} className="p-about__section p-about__section--head">
              <motion.div
                ref={ref}
                className="p-about__section-head-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={heroVariants.root}
              >
                <motion.div className="p-about__section-image" variants={heroVariants.image}>
                  <motion.div className="p-about__section-image-wrapper" style={{ y: heroParallax.image }}>
                    <MaskImage
                      start={inView}
                      video={
                        <video muted={true} playsInline={true}>
                          <source type="video/webm" src="/videos/mask.webm" />
                          <source type="video/mp4" src="/videos/mask.mp4" />
                        </video>
                      }
                    >
                      <picture>
                        <source
                          type="image/jpg"
                          media="(max-width: 768px)"
                          srcSet="/images/about/KV-sp.jpg, /images/about/KV-sp@2x.jpg 2x"
                        />
                        <source
                          type="image/jpg"
                          media="(min-width: 769px)"
                          srcSet="/images/about/KV.jpg, /images/about/KV@2x.jpg 2x"
                        />
                        <source
                          type="image/webp"
                          media="(max-width: 768px)"
                          srcSet="/images/about/KV-sp.webp, /images/about/KV-sp@2x.webp 2x"
                        />
                        <source
                          type="image/webp"
                          media="(min-width: 769px)"
                          srcSet="/images/about/KV.webp, /images/about/KV@2x.webp 2x"
                        />
                        <img
                          src="/images/about/KV.webp"
                          srcSet="/images/about/KV.webp, /images/about/KV@2x.webp 2x"
                          alt="About v-PaSSer"
                          width="1440"
                          height="540"
                        />
                      </picture>
                    </MaskImage>
                  </motion.div>
                </motion.div>
                <div className="p-about__section-text">
                  <Container>
                    <Row>
                      <Col width={3} widthSP={4}></Col>
                      <Col width={6} widthSP={4}>
                        <motion.div className="p-about__section-text-title" variants={heroVariants.title}>
                          <h1>About v-PaSSer</h1>
                        </motion.div>
                        <motion.div
                          className="p-about__section-text-description p-about__section-text-description--0"
                          variants={heroVariants.description}
                        >
                          <p>
                            v-PaSSer offers a wide range of payment & settlement solutions around the world. Our
                            technology helps clients growth in global community and adaptation to ever-increasing
                            complexity of settlement system.
                          </p>
                        </motion.div>
                      </Col>
                      <Col width={3} widthSP={4}></Col>
                    </Row>
                  </Container>
                </div>
              </motion.div>
            </section>
          )}
        </InView>

        {detailList.map((item, index) => (
          <section
            ref={index === 0 ? p1SectionRef : index === 1 ? p2SectionRef : p3SectionRef}
            key={index}
            className={`p-about__section p-about__section--${index + 1}`}
          >
            <InView triggerOnce>
              {({ inView, ref }) => (
                <motion.div
                  ref={ref}
                  className="p-about__section-image"
                  variants={pointVariants.image}
                  initial={false}
                  animate={inView ? 'enter' : 'exit'}
                >
                  <motion.div className="p-about__section-image-wrapper" style={{ y: pointParallaxs[index].image }}>
                    <MaskImage
                      start={inView}
                      video={
                        <video muted={true} playsInline={true} autoPlay={false}>
                          <source type="video/webm" src="/videos/mask.webm" />
                          <source type="video/mp4" src="/videos/mask.mp4" />
                        </video>
                      }
                    >
                      <picture>
                        <source type="image/jpg" media="(max-width: 768px)" srcSet={item.images.sp.jpg} />
                        <source type="image/jpg" media="(min-width: 769px)" srcSet={item.images.pc.jpg} />
                        <source type="image/jpg" media="(max-width: 768px)" srcSet={item.images.sp.webp} />
                        <source type="image/jpg" media="(min-width: 769px)" srcSet={item.images.pc.webp} />
                        <img
                          src={item.images.img.webp}
                          srcSet={item.images.pc.webp}
                          alt={item.title}
                          width="1440"
                          height="360"
                        />
                      </picture>
                    </MaskImage>
                  </motion.div>
                </motion.div>
              )}
            </InView>
            <InView key={index} triggerOnce>
              {({ inView, ref }) => (
                <motion.div
                  ref={ref}
                  className="p-about__section-text"
                  initial={false}
                  animate={inView ? 'enter' : 'exit'}
                  variants={pointVariants.content}
                >
                  <Container>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      <Col width={8} widthSP={4}>
                        <motion.div className="p-about__section-text-title" variants={pointVariants.text}>
                          <h2>{item.title}</h2>
                        </motion.div>
                      </Col>
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      {item.items.map((dItem, dIndex) => (
                        <Col key={`${index}-${dIndex}`} width={4} widthSP={4}>
                          <motion.div
                            className={mapModifiers('p-about__section-text-description', dIndex.toString())}
                            variants={pointVariants.text}
                          >
                            <p className="p-about__section-text-description-bullet">{dItem}</p>
                          </motion.div>
                        </Col>
                      ))}
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                  </Container>
                </motion.div>
              )}
            </InView>
          </section>
        ))}

        <InView triggerOnce>
          {({ inView, ref }) => (
            <section ref={footerSectionRef} className="p-about__section p-about__section--footer">
              <motion.div
                ref={ref}
                className="p-about__section-footer-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={footerVariants.root}
              >
                <motion.i variants={footerVariants.line} />
                <motion.div className="p-about__logo-img" variants={footerVariants.image}>
                  <motion.img
                    src="/images/logo.svg"
                    alt="v-PaSSer Logo"
                    width="319"
                    height="100"
                    style={{
                      y: footerStudyParallax.logo,
                    }}
                  />
                </motion.div>
              </motion.div>
            </section>
          )}
        </InView>

        {/* <!-- CASE STUDY --> */}
        <InView triggerOnce>
          {({ inView, ref }) => (
            <section ref={caseStudySectionRef} className="p-about__section p-about__section--case-study">
              <motion.div
                ref={ref}
                className="o-section-case-study"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={caseStudyVariants.root}
              >
                <Container>
                  <Row>
                    <Col className="o-section-case-study__heading-col" width={1} widthSP={4}>
                      <motion.div
                        className="o-section-case-study__heading"
                        variants={caseStudyVariants.heading}
                        style={{ y: caseStudyParallax.heading }}
                      >
                        <Heading modifiers="dot">Case Study</Heading>
                      </motion.div>
                    </Col>
                    <Col className="o-section-case-study__text-col" width={5} widthSP={4}>
                      <motion.div
                        className="o-section-case-study__text"
                        variants={caseStudyVariants.content}
                        style={{ y: caseStudyParallax.content }}
                      >
                        <motion.h1 className="o-section-case-study__text-title" variants={caseStudyVariants.text}>
                          Contributing
                          <br />
                          to Advancement
                        </motion.h1>
                        <motion.p className="o-section-case-study__text-subtitle" variants={caseStudyVariants.text}>
                          An ASEAN Country
                        </motion.p>
                        <motion.div className="o-section-case-study__text-action" variants={caseStudyVariants.cta}>
                          <Button onClick={() => viewPage('/case-study')}>VIEW MORE</Button>
                        </motion.div>
                      </motion.div>
                    </Col>
                    <Col className="o-section-case-study__image-col" width={6} widthSP={4}>
                      <div className="o-section-case-study__image">
                        <motion.figure
                          className="o-section-case-study__image-item"
                          variants={caseStudyVariants.image}
                          onAnimationStart={() => {
                            sectionPictureReveals.caseStudy = false;
                            setSectionPictureReveals(sectionPictureReveals);
                          }}
                          onAnimationComplete={() => {
                            sectionPictureReveals.caseStudy = true;
                            setSectionPictureReveals(sectionPictureReveals);
                          }}
                          style={{ y: caseStudyParallax.image }}
                        >
                          <MaskImage
                            start={sectionPictureReveals.caseStudy}
                            video={
                              <video muted={true} playsInline={true} autoPlay={false}>
                                <source type="video/webm" src="/videos/mask.webm" />
                                <source type="video/mp4" src="/videos/mask.mp4" />
                              </video>
                            }
                          >
                            <picture>
                              <source
                                type="image/jpg"
                                media="(max-width: 768px)"
                                srcSet="/images/home/case-study-sp.jpg, /images/home/case-study-sp@2x.jpg 2x"
                              />
                              <source
                                type="image/jpg"
                                media="(min-width: 769px)"
                                srcSet="/images/home/case-study.jpg, /images/home/case-study@2x.jpg 2x"
                              />
                              <source
                                type="image/webp"
                                media="(max-width: 768px)"
                                srcSet="/images/home/case-study-sp.webp, /images/home/case-study-sp@2x.webp 2x"
                              />
                              <source
                                type="image/webp"
                                media="(min-width: 769px)"
                                srcSet="/images/home/case-study.webp, /images/home/case-study@2x.webp 2x"
                              />
                              <img
                                src="/images/home/case-study.webp"
                                srcSet="/images/home/case-study.webp, /images/home/case-study@2x.webp 2x"
                                alt="Case Study"
                                width="375"
                                height="420"
                              />
                            </picture>
                          </MaskImage>
                        </motion.figure>
                        <motion.i
                          className="o-section-case-study__image-text"
                          variants={caseStudyVariants.imageText}
                          style={{ y: caseStudyParallax.imageText }}
                        >
                          C
                        </motion.i>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </motion.div>
            </section>
          )}
        </InView>
        {/* <!-- /CASE STUDY --> */}
        <section className="p-about__back">
          <BackButton path="/" />
        </section>
      </div>
    </Layout>
  );
};

export default withRouter(AboutPage);
